module.exports = __webpack_public_path__ + "static/media/design & technology.e872c3af.png";